import React from "react";

export const WarningDownload = () => (
  <div className="warning-container">
    <span>
      Aviso:{" "}
      <span className="warning-download">
        debe descargar las etiquetas ahora
      </span>
      , dado que no será posible hacerlo una vez se cierre esta ventana.
    </span>
  </div>
);
